module.exports = __webpack_public_path__ + "static/img/solution-case-m-en.054a6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution-case-m-en.png
// module id = +CYF
// module chunks = 1